import type { ResourceConfig } from '../../models/resource.model';
import rawEnv from './../inline-scripts/env.script';
import rawGtagConsent from './../inline-scripts/gtag-consent.defaults.script';
import rawDatadogRum from './../inline-scripts/datadog-rum.script';
import rawLeadooConsentReady from './../inline-scripts/leadoo-consent-ready.script';
import rawOptimizelyConsentReady from './../inline-scripts/optimizely-consent-ready.script';
import rawPardotConsentReady from './../inline-scripts/pardot-consent-ready.script';

export const globalResources: ResourceConfig[] = [
    {
        tag: 'link',
        location: 'head',
        attributes: { rel: 'preconnect', href: 'https://consent.cookiebot.com' },
    },
    {
        tag: 'link',
        location: 'head',
        attributes: { rel: 'preconnect', href: 'https://consentcdn.cookiebot.com' },
    },
    {
        tag: 'link',
        location: 'head',
        policy: { excludeCultures: ['zh-Hans'] },
        attributes: { rel: 'preconnect', href: 'https://cdn.optimizely.com' },
    },
    {
        tag: 'link',
        location: 'head',
        attributes: { rel: 'preconnect', href: 'https://www.googletagmanager.com' },
    },
    {
        tag: 'link',
        location: 'head',
        attributes: { rel: 'preconnect', href: 'https://a.storyblok.com' },
    },
    {
        tag: 'script',
        location: 'head',
        persist: true,
        textContent: rawEnv,
        attributes: { type: 'text/javascript', id: 'env-inline' },
    },
    {
        tag: 'script',
        location: 'head',
        textContent: rawGtagConsent,
        attributes: { type: 'text/javascript', id: 'gtag-consent-inline' },
    },
    {
        tag: 'script',
        location: 'head',
        persist: true,
        attributes: {
            'src': 'https://consent.cookiebot.com/uc.js',
            'type': 'text/javascript',
            'id': 'Cookiebot',
            'data-cbid': '25fda4a6-c10f-491b-9239-4b46413752d9',
            'async': true,
        },
    },
    {
        tag: 'script',
        location: 'body',
        textContent: rawDatadogRum,
        attributes: { type: 'text/javascript', id: 'datadog-rum-inline' },
    },
    {
        tag: 'script',
        location: 'head',
        textContent: rawLeadooConsentReady,
        // Leadoo breaks the Storyblok Visual Editor's block menu.
        policy: { excludeCultures: ['zh-Hans'], excludeInStoryblokPreview: true },
        attributes: { type: 'text/javascript', id: 'leadoo-consent-inline' },
    },
    {
        tag: 'script',
        location: 'head',
        textContent: rawOptimizelyConsentReady,
        // Keeps experiments out of the preview and editors out of experiment data.
        policy: { excludeCultures: ['zh-Hans'], excludeInStoryblokPreview: true },
        attributes: { type: 'text/javascript', id: 'optimizely-consent-inline' },
    },
    {
        tag: 'script',
        location: 'head',
        textContent: rawPardotConsentReady,
        policy: { excludeCultures: ['zh-Hans'] },
        attributes: { type: 'text/javascript', id: 'pardot-consent-inline' },
    },
];
